import { CheckCircle2, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';

export interface FeedbackDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feedback: string;
  onFeedbackChange: (value: string) => void;
  canSubmit: boolean;
  submitPending: boolean;
  errorMessage?: string | undefined;
  onResume: () => void;
  onClose: () => void;
}

export function FeedbackDialog(props: FeedbackDialogProps): JSX.Element {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Feedback note</DialogTitle>
          <DialogDescription>
            Add a note before closing or continuing this order.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {props.errorMessage && (
            <div
              role="alert"
              className="rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm"
            >
              <p className="font-medium">Changes were not saved</p>
              <p className="mt-1">{props.errorMessage}</p>
            </div>
          )}
          <Textarea
            value={props.feedback}
            onChange={(e) => props.onFeedbackChange(e.target.value)}
            placeholder="What changed, and why?"
            className="min-h-[140px]"
          />
          <p className="text-xs text-muted-foreground">Minimum 8 characters.</p>
        </div>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => props.onOpenChange(false)}
            disabled={props.submitPending}
          >
            Cancel
          </Button>
          <Button variant="destructive" onClick={props.onClose} disabled={!props.canSubmit}>
            <XCircle className="h-4 w-4" />
            Close without resume
          </Button>
          <Button onClick={props.onResume} disabled={!props.canSubmit}>
            <CheckCircle2 className="h-4 w-4" />
            Save + Resume
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
